







import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
let importAll = (requireContext: __WebpackModuleApi.RequireContext) => {
  return requireContext.keys().forEach(requireContext);
};

try {
  importAll(require.context("../assets/icons", true, /\.svg$/));
} catch (error) {
  console.log(error);
}
@Component
export default class Icon extends Vue {
  @Prop(String) name!: string;
  @Prop(String) classPrefix?: string;
}
